
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class Collapse extends Vue {
  @Prop({ default: false }) hasExpand!: boolean;
  @Prop({ default: true }) hasHover!: boolean;
  @Prop() active!: boolean;

  isExpand = false;
  height = 0;

  @Watch("active", { immediate: true })
  syncStatus(nval: boolean) {
    this.isExpand = nval;
  }

  changeExpand() {
    if (this.hasExpand) {
      this.isExpand = !this.isExpand;
      this.$emit("update:active", this.isExpand);
      this.$emit("change", this.isExpand);
    }
  }
}
